import {
  SET_EXPORT_DATA_LOADING,
  SET_EXPORT_DATA_LOADING_EXPORT,
  SET_PLUGIN_CHARGE_DATA,
} from './mutation-type'
import api from '@/api'
import { objectTrim, getHeaderName } from '@/utils'
import files from 'file-saver'

const ExportAPIMap = Object.freeze({
  pluginCharge: api.exportApi.exportPluginConsumption,
})
const DataInfoMap = Object.freeze({
  pluginCharge: {
    api: api.exportApi.queryPluginConsumption,
    commit: SET_PLUGIN_CHARGE_DATA,
  },
})

const state = {
  loadingDatas: false,
  loadingExport: false,
  pluginChargeData: {
    pageNum: 1,
    pageCount: 0,
    total: 0,
    size: 50,
    items: [],
    rmbTotalConsume: 0,
    usdTotalConsume: 0,
  },
}

const mutations = {
  [SET_EXPORT_DATA_LOADING](state, payload) {
    state.loadingDatas = payload
  },
  [SET_EXPORT_DATA_LOADING_EXPORT](state, payload) {
    state.loadingExport = payload
  },
  [SET_PLUGIN_CHARGE_DATA](state, payload) {
    state.pluginChargeData = payload
  },
}

const actions = {
  async getDatas({ commit }, { query, type }) {
    const dataInfo = DataInfoMap[type]
    const dataQuery = objectTrim(query, false, true)
    commit(SET_EXPORT_DATA_LOADING, true)
    const {code, data} = await dataInfo.api(dataQuery)
    if (code === 200) {
      commit(dataInfo.commit, data)
    }
    commit(SET_EXPORT_DATA_LOADING, false)
    return { code, data }
  },

  async exportExcel({ commit }, { query, type }) {
    const exportAPI = ExportAPIMap[type]
    const exportQuery = objectTrim(query, false, true)
    commit(SET_EXPORT_DATA_LOADING_EXPORT, true)
    const { data, headers } = await exportAPI(exportQuery)
    commit(SET_EXPORT_DATA_LOADING_EXPORT, false)
    const fileName = getHeaderName(headers)
    const blob = new Blob([data], { type: 'application/zip' })
    files.saveAs(blob, fileName)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
